"use strict";import{TopNavItem as e}from"./src/TopNavItem.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-top-nav-item",e);
//# sourceMappingURL=sp-top-nav-item.js.map
